import { graphql } from 'gql.tada'

import { EnterpriseNav } from '@/components/enterprise-nav'
import { WebFooter } from '@/components/web-footer'
import { WebTopHeader } from '@/components/web-top-header'
import { GuardianLayout } from '../guardian'
import { useClientOnly } from '@/hooks/useClientOnly'
import { useQuery } from '@/hooks/useQuery'
import { maybeGraphQLType } from '@/utils/graphql'
import { ContractSignErrorBoundary } from './ContractSignErrorBoundary'

interface Props {
  children: React.ReactNode
}

export const EnterpriseLayout = ({ children }: Props): JSX.Element => {
  return (
    <GuardianLayout>
      <ContractSignErrorBoundary>
        <EnterpriseLayoutInner>{children}</EnterpriseLayoutInner>
      </ContractSignErrorBoundary>
    </GuardianLayout>
  )
}

export const EnterpriseLayoutInner = ({ children }: Props): JSX.Element => {
  useClientOnly()

  const [{ data }] = useQuery({
    query: EnterpriseLayout_CurrentUserQuery,
  })
  const schoolName = maybeGraphQLType('SchoolUser')(data?.currentUser)?.school
    ?.name

  return (
    <div className="grid-areas-enterprise-layout">
      <div className="grid-area-header">
        <WebTopHeader />
        <section className="flex h-[100px] items-center justify-center bg-primary-75">
          <h2 className="text-[32px] font-bold text-white">{schoolName}</h2>
        </section>
      </div>
      <aside className="grid-area-nav bg-[#F5F7FC]">
        <EnterpriseNav />
      </aside>
      <article className="grid-area-content bg-white px-[72px] py-[42px]">
        {children}
      </article>
      <WebFooter className="grid-area-footer border-t border-disable" />
    </div>
  )
}

export function getEnterpriseLayout(page: React.ReactElement) {
  return <EnterpriseLayout>{page}</EnterpriseLayout>
}

const EnterpriseLayout_CurrentUserQuery = graphql(`
  query EnterpriseLayout_CurrentUserQuery {
    currentUser {
      __typename
      ... on SchoolUser {
        id
        school {
          id
          name
        }
      }
    }
  }
`)
